


















import { Component, Vue } from "vue-property-decorator";
import RegisterForm from "@/components/forms/RegisterForm.vue";

@Component({
  components: { RegisterForm },
})
export default class extends Vue {}
